import { Show, Tabs } from '@pankod/refine-antd';
import { useSearchParams } from '@pankod/refine-react-router-v6';
import { ProductBomTab, ProductEditTab } from 'components/product';

import { useEffect, useState } from 'react';

export const ProductEdit = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(searchParams.get('activeTab') || 'product-create');
  const [isBomTabEnabled, setIsBomTabEnabled] = useState<boolean>(false);

  useEffect(() => {
    // Update activeTab state if the URL changes
    const currentActiveTab = searchParams.get('activeTab') || 'product-create';
    if (currentActiveTab !== activeTab) {
      setActiveTab(currentActiveTab);
    }
  }, [searchParams, activeTab]);

  const onTabChange = (key: string) => {
    setSearchParams({
      ...Object.fromEntries(searchParams.entries()),
      activeTab: key,
    });
    setActiveTab(key); // Update the local activeTab state immediately
  };

  const handleBomTabEnabled = (enabled: boolean) => {
    setIsBomTabEnabled(enabled);
  };

  return (
    <Show title="Product Edit" headerProps={{ extra: null }}>
      <div style={{ padding: 0, margin: 0 }}>
        <Tabs activeKey={activeTab} onChange={onTabChange}>
          <Tabs.TabPane key="product-create" tab="General Information">
            <ProductEditTab handleBomTabEnabled={handleBomTabEnabled} />
          </Tabs.TabPane>

          <Tabs.TabPane key="bom-create" tab="Product Recipe / BOM" disabled={!isBomTabEnabled}>
            <ProductBomTab />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </Show>
  );
};
